import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  standalone: true,
  imports: [RouterModule, PdfViewerModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'white-label-front';
}
